import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "mdbreact/dist/css/mdb.css";
import { MDBCard, MDBCardBody, MDBCardTitle, MDBRow, MDBCol } from "mdbreact";
import content from "../Helpers/home-content-data";
import ShowMoreText from "react-show-more-text";

class HomeCardDeck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    let cards = content.items.map((item, key) => {
      return (
        <MDBCol md="4"  key={key} style={{margin:"2px"}}>
          <MDBCard>
            <MDBCardBody
              style={{
                height: "200px",
                overflowY: "auto",
                textAlign: "justify",
              }}
            >
              <MDBCardTitle style={{ color: "blue" }}>
                {item.caption}
              </MDBCardTitle>

              {/* <MDBCardText style={{textAlign:"justify"}}> */}
              <ShowMoreText
                lines={5}
                more="Show more"
                less="Show less"
                anchorClass=""
                onClick={this.executeOnClick}
                expanded={false}
              >
                <p style={{ textAlign: "justify" }}> {item.description}</p>
              </ShowMoreText>
              {/* </MDBCardText> */}
              {/* <div style={{align:"right"}}><h6 >More</h6></div> */}
            </MDBCardBody>
          </MDBCard>
        </MDBCol>
      );
    });
    return (
      <div style={{ padding: "10px" }}>
        <MDBRow center>{cards}</MDBRow>
      </div>
    );
  }
}

export default HomeCardDeck;
